import { useState, useCallback } from "react";
import {
  APIProvider,
  Map,
  Marker,
} from "@vis.gl/react-google-maps";
import { ENV_VAR } from "utils/envVariables";

export default function MapComponent({ onConfirmLocation, defaultCenter }) {
  return (
    <APIProvider apiKey={ENV_VAR.GOOGLE_MAPS_API_KEY}>
      <MapWrapper onConfirmLocation={onConfirmLocation} defaultCenter={defaultCenter} />
    </APIProvider>
  );
}

function MapWrapper({ onConfirmLocation, defaultCenter }) {
  const [position, setPosition] = useState({
    lat: defaultCenter.lat ?? defaultCenter.latitude,
    lng: defaultCenter.lng ?? defaultCenter.longitude,
  });

  const handleMapClick = useCallback((e) => {
    console.log('handleMapClick', e);
    setPosition({
      lat: e.detail.latLng.lat,
      lng: e.detail.latLng.lng,
    });
  }, []);

  const handleMarkerDragEnd = useCallback((e) => {
    console.log('handleMarkerDragEnd', e);
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();
    setPosition({ lat, lng });
  }, []);

  return (
    <div>
      <Map
        defaultCenter={position}
        reuseMaps={true}
        defaultZoom={18}
        zoomControl={true}
        cameraControl={false}
        streetViewControl={false}
        controlSize={25}
        gestureHandling="greedy"
        style={{ height: "50vh", width: "100%"}}
        onClick={handleMapClick}
      >
        <Marker
          position={position}
          draggable={true}
          onDragEnd={handleMarkerDragEnd}
        />
      </Map>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <button className="add-address-btn" type="submit" onClick={() => onConfirmLocation({
          latitude: position.lat,
          longitude: position.lng,
        })}>
          Confirm Location
        </button>
      </div>
    </div>
  );
}
